import apiClient from 'utilities/apiClient';

export const create_drum_label = (payload) => {
  return apiClient.post(`${apiClient.Urls.drumLabels}`, payload, true);
};

export const regenerate_missing_drum_pdfs = () => {
  return apiClient.post(
    `${apiClient.Urls.drumLabels}/regenerate-missing`,
    {},
    true
  );
};

export const get_drum_labels = (payload) => {
  return apiClient.get(`${apiClient.Urls.drumLabels}`, payload, true);
};

export const get_drum_label = (id) => {
  return apiClient.get(`${apiClient.Urls.drumLabels}/${id}`, {}, true);
};

export const clean_drum = (id) => {
  return apiClient.patch(`${apiClient.Urls.drumLabels}/${id}/clean`, {}, true);
};

export const allocate_drum_batch = (id, payload) => {
  return apiClient.patch(
    `${apiClient.Urls.drumLabels}/${id}/allocate`,
    payload,
    true
  );
};

export const change_drum_status = (id) => {
  return apiClient.patch(
    `${apiClient.Urls.drumLabels}/${id}/status-change`,
    {},
    true
  );
};

export const get_drum_counts = () => {
  return apiClient.get(`${apiClient.Urls.drumLabels}/counts`, {}, true);
};

export const get_drum_logs = (drumLabelNumber) => {
  return apiClient.get(
    `${apiClient.Urls.drumLabels}/${drumLabelNumber}/logs`,
    {},
    true
  );
};

export const bulk_clean_drums = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.drumLabels}/bulk-clean`,
    payload,
    true
  );
};

export const bulk_allocate_drums = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.drumLabels}/bulk-allocate`,
    payload,
    true
  );
};

export const bulk_status_change_drums = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.drumLabels}/bulk-status-change`,
    payload,
    true
  );
};

export const generate_usage_log_report = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.drumLabels}/usage-log-report`,
    payload,
    true
  );
};

export const bulkInactivateDrumsApi = (payload) =>
  apiClient.post(`${apiClient.Urls.drumLabels}/bulk-inactivate`, payload, true);

export const reactivateDrumApi = ({ drum_label_number, note }) =>
  apiClient.post(
    `${apiClient.Urls.drumLabels}/${drum_label_number}/reactivate`,
    { note },
    true
  );
